import {PermissionGuardBase} from "./permissionGuardBase.service";
import {IGuardMixin} from "./mixins/IGuardMixin";
import {LoggedGuardMixin} from "./mixins/loggedGuardMixin";
import {VerifiedGuardMixin} from "./mixins/verifiedGuardMixin";

export class VerifiedUserGuard extends PermissionGuardBase {
  protected guardMixins: IGuardMixin[] = [new LoggedGuardMixin(this.userService), new VerifiedGuardMixin(this.userService)];
}
